import { Notification } from "@mantine/core";
import { useState, useEffect } from "react";
interface NotificationProps {
  notify: string;
  message: string;
}

/**
 * Renders a Notification component based on the notify and message props.
 *
 * @param {string} notify - The type of notification (success, info, warning, error, loading)
 * @param {string} message - The message to be displayed in the notification
 * @return {JSX.Element} The rendered Notification component
 */
const Notifications = ({ notify, message }: NotificationProps) => {
  const [notification, setNotification] = useState<{
    title: string;
    message: string;
    color: string;
    loader: boolean;
  } | null>(null);

  useEffect(() => {
    let notificationDetails = {
      title: "",
      message: "",
      color: "",
      loader: false,
    };

    switch (notify) {
      case "success":
        notificationDetails = {
          title: "Success",
          message: message,
          color: "green",
          loader: false,
        };
        break;
      case "info":
        notificationDetails = {
          title: "Info",
          message: message,
          color: "blue",
          loader: false,
        };
        break;
      case "warning":
        notificationDetails = {
          title: "Warning",
          message: message,
          color: "yellow",
          loader: false,
        };
        break;
      case "error":
        notificationDetails = {
          title: "Error",
          message: message,
          color: "red",
          loader: false,
        };
        break;
      case "loading":
        notificationDetails = {
          title: "Loading...",
          message: message,
          color: "gray",
          loader: true,
        };
        break;

      default:
        break;
    }
    setNotification(notificationDetails);
  }, [notify, message]);

  return (
    <>
      {notification?.message && (
        <Notification
          title={notification.title}
          color={notification.color}
          loading={notification.loader}
          onClose={() => setNotification(null)}
          withCloseButton
        >
          {notification.message}
        </Notification>
      )}
    </>
  );
};

export default Notifications;
